import { cn } from '@/lib/utils'

/** Marchio SEPMA (rombo e due livelli) disegnato in SVG: nitido a ogni dimensione, colore da `currentColor`. */
export function SepmaMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="8.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={cn('shrink-0', className)}
    >
      <path d="M5.5 32 50 11l44.5 21L50 53Z" />
      <path d="m5.5 50.5 44.5 21 44.5-21" />
      <path d="m5.5 69 44.5 21 44.5-21" />
    </svg>
  )
}
